import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.55556 18C4.12778 18 3.76157 17.8433 3.45694 17.53C3.15231 17.2167 3 16.84 3 16.4V5.2C3 4.76 3.15231 4.38333 3.45694 4.07C3.76157 3.75667 4.12778 3.6 4.55556 3.6H5.33333V2H6.88889V3.6H13.1111V2H14.6667V3.6H15.4444C15.8722 3.6 16.2384 3.75667 16.5431 4.07C16.8477 4.38333 17 4.76 17 5.2V16.4C17 16.84 16.8477 17.2167 16.5431 17.53C16.2384 17.8433 15.8722 18 15.4444 18H4.55556ZM4.55556 16.4H15.4444V8.4H4.55556V16.4ZM4.55556 6.8H15.4444V5.2H4.55556V6.8Z",
		fill: "currentColor"
	})
});
export default SvgCalendar;
